import type { CookieConsentCopy } from './CookieConsentBanner';

/** English stock copy — also used as i18n defaultValue fallbacks. */
export const COOKIE_CONSENT_EN = {
  title: 'Cookies & local storage',
  body:
    'We use essential cookies and local browser storage so this site works (session, language, offline cache, and your preferences). Optional storage improves the experience. You can accept all or continue with essentials only.',
  accept: 'Accept all',
  essential: 'Essentials only',
  policy: 'Cookie policy',
} as const;

type TranslateFn = (key: string, options?: { defaultValue?: string }) => string;

/**
 * Build CookieConsentBanner `copy` from an i18next `t` (or compatible) function.
 * Keys: cookieConsent.title | body | accept | essential | policy
 */
export function cookieConsentCopyFromT(
  t: TranslateFn,
  opts?: { policyHref?: string },
): CookieConsentCopy {
  return {
    title: t('cookieConsent.title', { defaultValue: COOKIE_CONSENT_EN.title }),
    body: t('cookieConsent.body', { defaultValue: COOKIE_CONSENT_EN.body }),
    acceptLabel: t('cookieConsent.accept', { defaultValue: COOKIE_CONSENT_EN.accept }),
    essentialLabel: t('cookieConsent.essential', { defaultValue: COOKIE_CONSENT_EN.essential }),
    policyLabel: t('cookieConsent.policy', { defaultValue: COOKIE_CONSENT_EN.policy }),
    policyHref: opts?.policyHref ?? '/cookies',
  };
}
